import { createLayupClient } from './layupApi';

export const getAggregatedGraphData = async () => {
  const client = createLayupClient(false);

  const results = await Promise.allSettled([
    client.get('v1/graphs/orders?interval=NONE'),
    client.get('v1/graphs/payment-plans?interval=NONE&state=PLACED&months=60'),
    client.get('v1/graphs/paymentsDue?due=30'),
    client.get('v1/graphs/payment-plans?interval=NONE&state=PLACED,CANCELLED,COMPLETED'),
  ]);

  const [ordersByStatus, planValue, paymentsDue, planValueAverage] = results.map((result) =>
    result.status === 'fulfilled' ? result.value.data : null,
  );

  return { ordersByStatus, planValue, paymentsDue, planValueAverage };
};

export const getOrdersGraphData = async () => {
  const client = createLayupClient(false);
  const paymentPlanAnalysis = await client.get('v1/graphs/orders');

  return paymentPlanAnalysis;
};

export const getPaymentPlanGraphsData = async () => {
  const client = createLayupClient(false);
  const paymentPlanAnalysis = await client.get('v1/graphs/payment-plans');

  return paymentPlanAnalysis;
};

export const getPaymentsGraphData = async () => {
  const client = createLayupClient(false);
  const paymentPlanAnalysis = await client.get('v1/graphs/payments');

  return paymentPlanAnalysis;
};
